export const VIDEO_LIST_REQUEST = 'VIDEO_LIST_REQUEST'
export const VIDEO_LIST_SUCCESS = 'VIDEO_LIST_SUCCESS'
export const VIDEO_LIST_FAIL = 'VIDEO_LIST_FAIL'
export const NOTION = 'NOTION'
export const OBSIDIAN = "OBSIDIAN"
export const LOGSEQ = "LOGSEQ"
export const TECHNIQUES = "TECHNIQUES"
export const ALL = "ALL"
